module.exports = __webpack_public_path__ + "fonts/Prompt-ExtraBoldItalic.2884861b.ttf";